
export const xmlFormatter = (data) => {
    data = data.toString()

    data = data.replace(/&(?!amp;|lt;|gt;|quot;|apos;)/g, '&amp;')

    return data
}